import React from 'react';
import { Eye } from 'lucide-react';
import { t } from '../../i18n/languages';

const UserDetailsModal = ({
  show,
  user,
  onClose,
  currentLanguage,
  yearStatus
}) => {
  if (!show || !user) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '24px',
        maxWidth: '500px',
        width: '90%',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
      }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            backgroundColor: '#eff6ff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <Eye size={24} color="#3b82f6" />
          </div>
          <h3 style={{
            margin: 0,
            fontSize: '20px',
            fontWeight: '600',
            color: '#1f2937'
          }}>
            {currentLanguage === 'hr' ? 'Detalji Zaposlenika' : 'Employee Details'}
          </h3>
        </div>

        {/* User Details */}
        <div style={{ display: 'grid', gap: '16px', marginBottom: '20px' }}>
          <ReadOnlyField label={t('username', {}, currentLanguage)} value={user.username} />
          <ReadOnlyField label="Email" value={user.email} />
          <ReadOnlyField label={t('firstName', {}, currentLanguage)} value={user.first_name} />
          <ReadOnlyField label={t('lastName', {}, currentLanguage)} value={user.last_name} />
          <ReadOnlyField label={t('role', {}, currentLanguage)} value={user.role === 'admin' ? (t('admin', {}, currentLanguage)) : (t('employee', {}, currentLanguage))} />
          <ReadOnlyField label={'OIB'} value={user.oib} />
          <ReadOnlyField label={t('employmentType', {}, currentLanguage)} value={user.employment_type === 'full-time' 
          ? t('fullTime', {}, currentLanguage) 
          : t('partTime', {}, currentLanguage) || '-'} />
          <ReadOnlyField label={t('vacationDays', {}, currentLanguage)} value={user.vacation_contract} />
          <ReadOnlyField
            label={
              currentLanguage === 'hr'
                ? `G.O. za tekuću godinu (${yearStatus?.currentOpenYear || new Date().getFullYear()})`
                : `Vacation for Current Year (${yearStatus?.currentOpenYear || new Date().getFullYear()})`
            }
            value={user.current_year_vacation}
          />
          <ReadOnlyField
            label={t('employmentStartDate', {}, currentLanguage)}
            value={user.employment_start_date}
          />
        </div>

        {/* Close button */}
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button
            type="button"
            onClick={onClose}
            style={cancelBtnStyle}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#f3f4f6';
              e.target.style.color = '#374151';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#6b7280';
            }}
          >
            {t('close', {}, currentLanguage)}
          </button>
        </div>
      </div>
    </div>
  );
};

const ReadOnlyField = ({ label, value }) => (
  <div>
    <label style={labelStyle}>{label}</label>
    <input
      type="text"
      value={value || ''}
      readOnly
      style={{ ...inputStyle, backgroundColor: '#f9fafb', color: '#6b7280', cursor: 'default' }}
    />
  </div>
);

const labelStyle = {
  display: 'block',
  fontSize: '14px',
  fontWeight: '500',
  color: '#374151',
  marginBottom: '6px'
};

const inputStyle = {
  width: '100%',
  padding: '10px 12px',
  border: '1px solid #d1d5db',
  borderRadius: '6px',
  fontSize: '14px'
};

const cancelBtnStyle = {
  padding: '10px 20px',
  backgroundColor: 'transparent',
  color: '#6b7280',
  border: '1px solid #d1d5db',
  borderRadius: '8px',
  fontSize: '14px',
  fontWeight: '500',
  cursor: 'pointer',
  transition: 'all 0.2s'
};

export default UserDetailsModal;
